import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Col, Row, Input } from 'reactstrap';
import { getCorprateUrl } from '../../../shared/components/domainSupport';
import { jsonHeader, serverUrl, isProdEnv } from '../../../config';
import LoadingSpinner from '../../../shared/components/widgets/LoadingSpinner';
import Alert from '../../../shared/components/Alert';
import FilterSelect from '../../../shared/components/filters/FilterSelect';

export default function DspOnboarding() {
  const selectedAccount = useSelector(store => store.sellerSelect);
  const user = useSelector(store => store.authentication.user);
  const [dspAdvertisersCSV, setDspAdvertisersCSV] = useState('');
  const [dspManager, setDspManager] = useState({});
  const [dspManagerOptions, setDspManagerOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [localAlert, setLocalAlert] = useState({});

  useEffect(() => {
    setLoading(true);
    setDspAdvertisersCSV('');
    setDspManager({});
    setLocalAlert({});
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
    // Add logic to check input values, make sure they are present and correct.
    const specsOptions = {
      method: 'GET',
      headers: headerWithAuth,
    };

    const specsUrl = `${serverUrl}/dsp/config/${selectedAccount.value}`;
    fetch(specsUrl, specsOptions)
      .then(async (results) => {
        if (!results.ok) {
          const text = await results.text();
          throw new Error(text);
        }
        return results.json();
      }).then((data) => {
        if (!isProdEnv) {
          console.info(data);
        }
        if (data.dspAdvertisersCSV) {
          setDspAdvertisersCSV(data.dspAdvertisersCSV);
          setLocalAlert({ color: 'warning', message: 'Found a linked advertiser(s), only update if needed' });
        }
        if (data.dspManager) {
          setDspManager(data.dspManager);
        }
        setDspManagerOptions(data.dspRegions);
      }).catch((error) => {
        setLocalAlert({ color: 'danger', message: JSON.stringify(error) });
      });
    setLoading(false);
  }, [selectedAccount.value]);

  const linkDsp = () => {
    setLoading(true);
    setLocalAlert({});
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
    // Add logic to check input values, make sure they are present and correct.
    if (dspAdvertisersCSV !== '' && dspManager.value) {
      const dspOptions = {
        method: 'POST',
        headers: headerWithAuth,
        body: JSON.stringify({
          dspAdvertisersCSV,
          dspManagerID: dspManager.value,
        }),
      };

      const postUrl = `${serverUrl}/dsp/config/${selectedAccount.value}`;
      fetch(postUrl, dspOptions)
        .then(async (results) => {
          if (!results.ok) {
            const text = await results.text();
            throw new Error(text);
          }
          return results.json();
        }).then((data) => {
          if (!isProdEnv) {
            console.info(data);
          }

          const updates = [];
          data.forEach(update => {
            updates.push(`${update.field} - ${update.status}`);
          })

          setLocalAlert({ color: 'primary', message: `Data Save Results: ${updates.join(', ')}` });
        }).catch((error) => {
          setLocalAlert({ color: 'danger', message: JSON.stringify(error) });
          console.error(error);
        });
    } else {
      setLocalAlert({ color: 'danger', message: 'Please fill in required fields' });
    }
    setLoading(false);
  }

  return (
    <Col md={12}>
      <Card>
        <Row>
          <Col md={5}>
            <CardBody>
              <LoadingSpinner active={loading} />
              {!loading && (
                <>
                  <div className="form__form-group">
                    {localAlert && localAlert.message && (
                      <Alert color={localAlert.color}>{localAlert.message}</Alert>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">DSP Advertiser(s) in CSV format</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="dspAdvertisersCSV"
                        component="input"
                        type="text"
                        value={dspAdvertisersCSV}
                        onChange={(e) => setDspAdvertisersCSV(e.target.value)}
                        maxLength={255}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!dspAdvertisersCSV || dspAdvertisersCSV === '') && (
                      <div className="form__form-group-error">DSP Advertisers CSV is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">DSP Mananger</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setDspManager}
                        options={dspManagerOptions}
                        selected={dspManager}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!dspManager.value) && (
                      <div className="form__form-group-error">A DSP Manager is required</div>
                    )}
                  </div>
                  <br />
                  <div className="form__form-group">
                    <button className="btn btn-primary customer__btn" type="submit" disabled={loading} onClick={() => linkDsp()}>Link DSP Account</button>
                  </div>
                </>
              )}
            </CardBody>
          </Col>
          <Col md={5}>
            <CardBody>
              <br />
              <p>PLEASE NOTE:<br /><br /></p>
              <blockquote><p>This will link a DSP account to this account</p></blockquote>
              <br />
              <blockquote><p>Data populated will indicate if an account is allready linked</p></blockquote>
              <br />
              <blockquote><p>By Clicking &apos;Create Customer&apos;, you agree to our <a href={`${getCorprateUrl()}/terms-of-use`} rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a></p></blockquote>
              <br />
            </CardBody>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
